import { FC } from "react";
import Box from "@mui/material/Box";
import { CompetitorKeyDetection } from "./charts/CompetitorKeyDetection/CompetitorKeyDetection";
import { CompetitorMarketPenetration } from "./charts/CompetitorMarketPenetration/CompetitorMarketPenetration";
import { CompetitorMarketPenetrationBySegmentChart } from "./CompetitorMarketPenetrationBySegmentChart";
import { CompetitorMarketPenetrationTrend } from "./charts/CompetitorMarketPenetrationTrend/CompetitorMarketPenetrationTrend";
import { CompetitorMarketPresence } from "./charts/CompetitorMarketPresence/CompetitorMarketPresence";
import { CompetitorNewProductDetections } from "./charts/CompetitorNewProductDetections/CompetitorNewProductDetections";
import { CompetitorPresenceByDepartmentChart } from "./charts/CompetitorPresenceByDepartmentChart/CompetitorPresenceByDepartmentChart";
import { CompetitorNewProductDetectionsBySegment } from "./CompetitorNewProductDetectionsBySegment";
import { CompetitorNewProductDetectionsOverTime } from "./CompetitorNewProductDetectionsOverTime";
import LazyRenderer from "../../../../components/LazyRenderer";
import { useIntersectionObserver } from "../../../../components/IntersectionObserver";

export const CompetitiveAnalysis: FC = () => {
  const { container } = useIntersectionObserver();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="10px"
      width="100%"
      minWidth={0}
      maxWidth="100%"
    >
      <CompetitorMarketPresence />
      <LazyRenderer
        root={container.current || undefined}
        fallback={<></>}
        threshold={0.1}
      >
        <CompetitorMarketPenetration />
      </LazyRenderer>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        gap="10px"
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <CompetitorMarketPenetrationTrend />
          </LazyRenderer>
        </Box>
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <CompetitorMarketPenetrationBySegmentChart />
          </LazyRenderer>
        </Box>
      </Box>

      <LazyRenderer
        root={container.current || undefined}
        fallback={<></>}
        threshold={0.1}
      >
        <CompetitorNewProductDetections />
      </LazyRenderer>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        gap="10px"
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <CompetitorNewProductDetectionsOverTime />
          </LazyRenderer>
        </Box>
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <CompetitorNewProductDetectionsBySegment />
          </LazyRenderer>
        </Box>
      </Box>

      <LazyRenderer
        root={container.current || undefined}
        fallback={<></>}
        threshold={0.1}
      >
        <CompetitorKeyDetection />
      </LazyRenderer>
      <LazyRenderer
        root={container.current || undefined}
        fallback={<></>}
        threshold={0.1}
      >
        <CompetitorPresenceByDepartmentChart />
      </LazyRenderer>
    </Box>
  );
};
